export default {
    users(state) {
        return state.users;
    },
    queues(state) {
        return state.queues;
    },
    queueIds(state) {
        const queueIds = [];

        for (const queue of state.queues) {
            queueIds.push(queue.id);
        }

        return queueIds;
    },
    ignoredQueues(state) {
        return state.ignoredQueues;
    },
    queuesForSelect(state) {
        const queues = [];

        const combinedQueues = state.queues.concat(state.ignoredQueues);

        for (const index in combinedQueues) {
            const queueItem = {
                id: combinedQueues[index].id,
                text: combinedQueues[index].name
            }

            queues.push(queueItem);
        }

        return queues;
    },
    liveFeedCounts(state) {
        return state.liveFeedCounts;
    },
    stats(state) {
        return state.stats;
    }
}